import '/modules/common/css/timeseries/container.css';
import '/modules/common/css/timeseries/container.responsive.css';
import '/modules/common/css/timeseries/container.mobile.css';
import * as $ from "jquery";
import {UIElement} from "../ui/ui";

/**
 * An abstract container is an element of a report that contains something like a chart or a time selector
 * @abstract
 * @extends UIElement
 */
export class AbstractContainer extends UIElement {

    /**
     *
     * @param id {string} The HTML id for this container
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     **/
    constructor(id, translator, isMobileDevice, runtimeConfig) {
        super(id, translator, isMobileDevice, runtimeConfig, undefined);
    }

    getClassName() {
        return "AbstractContainer";
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $('<li role="listitem" class="element timeseries-container"></li>');
            const container = this.getContainerElement();
            this.uiElement.append(container);

            if(this.isCollapsible()) {
                $('.buttons-container button.expander, .header>.title', this.uiElement).click(() => {
                    if (this.isExpanded()) {
                        this.collapse();
                        this.logStat("COLLAPSE");
                    } else {
                        this.expand();
                        this.logStat("EXPAND");
                    }
                });
            }
        }
        return this.uiElement;
    }

    /**
     * Generate elements to insert into this container
     * @return {jQuery}
     */
    getContainerElement() {
    }

    isCollapsible(){
        return true;
    }

    /**
     * Is this container expanded?
     * @return {boolean}
     */
    isExpanded() {
        if(!this.isCollapsible())
            return true;
        return this.getSessionProp("expanded") !== false;
    }

    /**
     * Expand container
     */
    expand() {
        this.setSessionProp("expanded", true);
        $('.buttons-container button.expander', this.uiElement)
            .addClass('collapse')
            .removeClass('expand');
        $('.container', this.uiElement).addClass('expanded');
        $('.body', this.uiElement).attr('aria-expanded', 'true');
        this._onExpand();
    }

    /**
     * Collapse container
     */
    collapse() {
        if(this.isCollapsible()) {
            this.setSessionProp("expanded", false);
            $('.buttons-container button.expander', this.uiElement)
                .addClass('expand')
                .removeClass('collapse');
            $('.container', this.uiElement).removeClass('expanded');
            $('.body', this.uiElement).attr('aria-expanded', 'false');
            this._onCollapse();
        }
    }

    /**
     * Override to specify behaviour after expand
     */
    _onExpand(){}

    /**
     * Override to specify behaviour after collapse
     */
    _onCollapse(){}

    /**
     * To be called by the owner of this container when it's added to the DOM
     * Override to specify behaviour at this moment
     */
    onAdd2DOM(){}
}